import React, { useEffect, useRef } from "react";
import Typed from "./type"; // Updated import statement

const TypeWriter = () => {
  const el = useRef(null); 
  const typed = useRef(null);

  useEffect(() => {
    if (el.current) {
      typed.current = new Typed(el.current, {
        strings: ["Network and Security", "Web Development", "Graphic Designing", "SEO", "E-Commerce"],
        typeSpeed: 50,
        backSpeed: 50,
        backDelay: 2000,
        loop: true,
      });
    }

    return () => {
      typed.current?.destroy();
    };
  }, []);

  return <h2 style={{color:"#FEAF39"}} className="type-heading" ref={el}></h2>;
};

export default TypeWriter;
